import React, { forwardRef } from 'react';

import { ButtonBase } from '@mui/material';
import clsx from 'clsx';
import { CrossIcon } from 'src/components/icons/CrossIcon';
import { IconColors } from 'src/components/icons/icon-utils';
import { makeStyles } from 'tss-react/mui';

interface CrossIconCircleButtonProps extends React.HTMLAttributes<HTMLElement> {
  onClick: (e: React.MouseEvent) => void;
  dataCy?: string;
  disabled?: boolean;
}

const useStyles = makeStyles<Pick<CrossIconCircleButtonProps, 'disabled'>>()(
  (theme, { disabled }) => ({
    crossIcon: {
      height: 15,
      width: 15,
    },
    iconCircle: {
      '&:hover': {
        backgroundColor: disabled ? theme.palette.action.disabled : theme.appColors.buttonHover,
      },
      alignItems: 'center',
      backgroundColor: disabled ? theme.palette.action.disabled : theme.palette.primary.main,
      borderRadius: '50%',
      display: 'flex',
      height: 24,
      justifyContent: 'center',
      width: 24,
    },
  })
);

export const CrossIconCircleButton = forwardRef(function CrossIconCircleButton(
  { className, dataCy, disabled, onClick }: CrossIconCircleButtonProps,
  ref: React.Ref<HTMLButtonElement>
): JSX.Element {
  const { classes } = useStyles({ disabled });

  return (
    <ButtonBase
      ref={ref}
      className={clsx(classes.iconCircle, className)}
      data-cy={dataCy}
      disabled={disabled}
      onClick={onClick}
    >
      <CrossIcon className={classes.crossIcon} fill={IconColors.White} />
    </ButtonBase>
  );
});
